import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ScreenDisplay from "./pages/ScreenDisplay";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Screen Display Routes */}
          <Route path="/screen/:id" element={<ScreenDisplay />} />
          
          {/* Admin - direct access, no login needed */}
          <Route path="/admin" element={<AdminDashboard />} />
          
          {/* Redirect root to admin */}
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="/login" element={<Navigate to="/admin" replace />} />
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
